import { Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { UtilityService } from './utility.service';
import { IOAuthService } from '../user/iOAuthService';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  identityBaseurl: string;
  constructor(
    @Inject('IDENTITYSERVER_URL') identityBaseUrl: string,
    private translate: TranslateService,
    public utility: UtilityService,
    private oAuthService: IOAuthService) {
    this.identityBaseurl = this.utility.removeSlashFromUrlAtEnd(identityBaseUrl);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    let token = this.oAuthService.getAccessToken();
    let entity = localStorage.getItem('_entityId');
    const currentPageUrl = window.location.href;  // ✅ Full page URL
    
    if (token) {
      if (request.url.includes(this.identityBaseurl)) {
        let sessionId = localStorage.session_state;
        request = request.clone({

          setHeaders: {
            Authorization: `Bearer ${token}`,
            SessionId: sessionId || "",
            entityId: entity || "",
            'X-Page-Referrer': currentPageUrl  // ✅ Custom header sent to backend

          }
        });
      } else {
        let sessionId = localStorage.session_state;
        request = request.clone({

          setHeaders: {
            Authorization: `Bearer ${token}`,
            SessionId: sessionId || "",
            entityId: entity || "",
            'X-Page-Referrer': currentPageUrl  // ✅ Custom header sent to backend

          },
          setParams: {
            lang: localStorage.getItem('lang')
          }
        });
      }
    }
    return next.handle(request);
  }
}
